<template>
    <div>
        <CRow>
            <CCol xs="12" sm="12" md="4" lg="4" xl="3">
                <CCard>
                    <CCardHeader class="d-flex justify-content-between">
                        <b><i class="fas fa-solid fa-award"></i>&nbsp;Garantías</b>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol sm="12">
                                <CSelect label="Sedes" :options="data_campus" placeholder="--Seleccione una sede --"
                                    :value.sync="selectedCampus" @change="onCampusChange" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Desde" type="date" aria-label="shift_date" @input="onCampusChange"
                                    size="sm" id="init" v-model="filter.init" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Hasta" type="date" aria-label="shift_date" @input="onCampusChange"
                                    id="end" size="sm" v-model="filter.end" />
                            </CCol>
                            <CCol xs="12" sm="12" md="12" lg="12" xxl="12">
                                <CInput label="Total de registros" type="text" size="sm" v-model="totalCompras"
                                    disabled />
                            </CCol>
                        </CRow>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol xs="12" sm="12" md="8" lg="8" xl="9">
                <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
                    caption="Lista de compras" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'"
                    :actions="true" :myButtons="myButtons" @mtd_ticket="mtd_ticket">
                </CTableWrapper>
            </CCol>
        </CRow>

    </div>
</template>

<script>
const fields = [
    { key: "index", label: "ID", _style: "width:1%" },
    { key: "name_client", label: "Nombre del cliente", _style: "width:10%;" },
    { key: "document", label: "N° documento de cliente", _style: "width:10%;" },
    { key: "address", label: "Dirección", _style: "width:10%;" },
    { key: "date_sale", label: "Fecha de la venta", _style: "width:10%;" },
    { key: "code_product", label: "Código de producto", _style: "width:10%;" },
    { key: "model_product", label: "Modelo del electrificador", _style: "width:10%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
    components: {
        CTableWrapper,

    },
    data() {
        return {
            prefix: "sales",
            fields,
            data: [],
            data_campus: [],
            totalCompras: 0,
            sumaTotalCompras: 0,
            filter: {
                init: null,
                end: null,
            },
            labelIcon: {
                labelOn: "\u2713",
                labelOff: "\u2715",
            },
            componentKey: 0,
            selectedCampus: null,
            myButtons: [
                {
                    class: "btn-sm",
                    color: "dark",
                    tooltip: "Ticket",
                    action: "mtd_ticket",
                    icon: "fas fa-file-pdf",
                },
            ],
        };
    },
    computed: {
        cpStatus: function () {
            if (this.companies.state == 1) return true;
            return false;
        },
    },
    created() {
        moment.locale("es");
        this.filter.end = moment().format("YYYY-MM-DD");
        this.filter.init = this.filter.end;
        this.mtd_data();
        this.getCampus();
    },
    methods: {
        ...mapActions(["get", "post"]),
        getCampus() {
            this.get({
                url:
                    this.$store.getters.get__url +
                    "/stock_transfer/getCampus/" +
                    this.$store.getters.get_company.id,
                token: this.$store.getters.get__token,
            }).then((response) => {
                if (response.statusCode == 200) {
                    this.data_campus = [
                        { label: "Todos", value: null },
                        ...response.data.map((element) => ({
                            label: element.name,
                            value: element.id,
                        })),
                    ];
                }
            });
        },
        onCampusChange() {
            if (this.selectedCampus === null) {
                this.mtd_data();
            } else {
                this.mtd_data(this.selectedCampus);
            }
        },
        mtd_data(campuId = null) {
            if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Por favor, selecciona un rango de fechas válido.',
                });
            }
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/warranty",
                token: this.$store.getters.get__token,
                params: {
                    init: this.filter.init,
                    end: this.filter.end,
                    campu_id: campuId,
                    company_id: this.$store.getters.get_company.id,
                },
            })
                .then((response) => {
                    this.clearData();
                    this.data = response.data.data;
                    this.totalCompras = this.data.length;
                    this.sumaTotalCompras = this.data.reduce((sum, item) => sum + parseFloat(item.total || 0), 0).toFixed(2);
                    this.data.forEach((item) => {
                        item.name_client = item.client.name;
                        item.document = item.client.document;
                        item.address = item.client.address ? item.client.address : 'Dirección no registrada';
                        item.date_sale = moment(item.sale.date).format("DD/MM/YYYY");
                        item.code_product = item.code;
                        item.model_product = item.product.name;
                    });
                    let index = 1;
                    this.data.forEach((arr) => {
                        arr.index = index;
                        index++
                    });
                })
                .catch((errors) => {
                    Swal.fire({
                        title: errors,
                        icon: "danger",
                    });
                });
        },
        mtdBack: function () {
            this.$emit("mtdBack");
        },
        clearData() {
            this.data = [];
            this.totalCompras = 0;
            this.sumaTotalCompras = 0;
        },
        mtd_ticket(item) {
            if (item?.sale?.voucher?.[0]?.id && item?.sale?.voucher?.[0]?.detail) {
                const voucher = item.sale.voucher[0].id;
                // const idProduct = item.voucher[0].detail;
                const document_name = item.sale.voucher[0].document_type.name;
                if (document_name == "NOTA DE VENTA") {
                    window.open(
                        this.$store.getters.get__url +
                        "/sales/ticket/" +
                        voucher +
                        // "/" +
                        // idProduct +
                        "/" +
                        this.$store.getters.get__user_id,
                        "_blank"
                    );
                } else {
                    const sunatData = JSON.parse(item.voucher[0].sunat);
                    const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
                    window.open(ticketUrl, "_blank");
                }
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Ticket",
                    text: "Está venta no tiene documento no tiene documento",
                });
            }
        },
    },

};
</script>

<style lang="scss" scoped></style>